
export default class Support
{
  static view(user, ticket)
  {
    return user.slug == ticket.slug;
  }
  
  static delete(user, ticket)
  {
    // admin
    if (user.role === 'admin') {
      return true;
    }

    // owner
    if (user.slug === ticket.slug) {
      return true;
    }

    return false;
  }
}
